import React, { Component, useEffect, useState } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';

import MapView from './MapView';
import BookmarkButton from './BookmarkButton';
import BreadCrumbs from './BreadCrumbs';
import OrnefnaskraDownloadLink from './OrnefnaskraDownloadLink'
import AbendingForm from './AbendingForm';

import config from './../config';

const useCheckMobileScreen = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
            setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return (width <= 768);
}

function PdfView(props) {
	const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

	return width < 768 ? <iframe src={'https://docs.google.com/viewer?url='+encodeURIComponent(props.url)+'&embedded=true'} width="100%" height="100%" /> :
		<object data={props.url} type="application/pdf" width="100%" height="100%">
			<p style={{margin: 5}}>Smelltu <a href={props.url}>hér</a> til að ná í pdf skrána.</p>
		</object>
}

class OrnefnaskraView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/ornefnaskrar/';
		this.mapView = React.createRef();

		this.state = {
			selectedTab: 'pdf',
			maximizeResults: false
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.id) {
			this.fetchData();
		}

		if (this.props.match && this.props.match.params.tab) {
			this.setState({
				selectedTab: this.props.match.params.tab
			});
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}

		if (this.props.match.params.tab != prevProps.match.params.tab) {
			this.setState({
				selectedTab: this.props.match.params.tab
			});
		}
	}

	fetchData() {
		let params = [];

		fetch(this.url+this.props.match.params.id+'/')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json,
					mapData: _.compact(json.baeir.map((item) => {
						if (item.lat && item.lng) {
							return {
								id: 1,
								label: item.baejarnafn,
								district: (item.sveitarfelag ? item.sveitarfelag.nafn+', ' : '')+item.sysla.nafn,
								type: 'farm',
								latLng: [item.lat, item.lng],
								tegund: item.tegund
							}
						}
					})),
					mapListData: json.ornefni ? _.compact(json.ornefni.map((ornefni) => {
						if (ornefni.uuid) {
							return  {
								id: ornefni.id,
								label: ornefni.ornefni,
								type: 'lmi_ornefni',
								uuid: ornefni.uuid
							}
						}
					})) : [],
					featureData: json.ornefni ? _.compact(json.ornefni.map((ornefni) => ornefni.uuid)) : []
				});
			}.bind(this));
	}

	render() {
		let item = this.state.data;

		return (
			<div className={'row boxes'+(this.state.maximizeResults ? ' maximize-results' : '')}>

				<div className={'col col-12'}>
					{
						item &&
						<div className="column-content full-screen">


							<div className="row">

								<div className="col col-12 col-md-5 main-column">
									<BreadCrumbs path={[
										item.sysla ? {
											path: '/syslur/'+item.sysla.id,
											title: item.sysla.nafn
										} : null,
										item.hreppur ? {
											path: '/hreppur/'+item.hreppur.id,
											title: item.hreppur.nafn
										} : null,
										{
											path: '1',
											title:item.titill
										}
									]} />

									{
										item.fjoldi_ornefna > 0 &&
										<div className="card contact-form">
											<div className="card-body">
												<h3> Þekkir þú til á þessum slóðum? </h3>
												<p> Smelltu á hnappinn og skráðu þig, og leggðu Árnastofnun og
													Landmælingum Íslands lið við hnitsetningu örnefna. </p>
												<React.Fragment>

													<a href={item.lmi}
													   className="btn btn-primary" target="_blank">Hvar er?</a>
												</React.Fragment>
											</div>
										</div>

									}
									<br />

									<div>
										<BookmarkButton title={item.titill} id={item.id} baer={null} baer_id={null} type={'skra'} className="float-right" />
										<OrnefnaskraDownloadLink label="Hlaða niður" className="float-right mr-2" data={item} />
										<h3>{item.titill} {item.artal && item.artal.artal_skrar != null ? ' ('+item.artal.artal_skrar+')': ''}</h3>
									</div>

									<hr/>
									{
										item.tegund && item.tegund.length > 0 &&
										<p className="mb-5"><strong>Tegund:</strong> {
											item.tegund.map((tegund, index) => <span key={index} className="badge badge-light" to={'/leit/ornefni/*/tegund/'+tegund.id}>{tegund.tegund}</span>)
										}</p>
									}
									{/*<p><strong>Hreppur:</strong> <a className="badge badge-light" href="/">Hálsahreppur</a> <strong>Sýsla:</strong> <a className="badge badge-light" href="/">Borgarfjarðarsýsla</a></p>*/}

									{
										item.einstaklingar && item.einstaklingar.length > 0 &&
										<React.Fragment>
											<h5>Tengdir einstaklingar</h5>
											<table className="mb-5 table">
												<tbody>
													{
														item.einstaklingar.map((einstaklingur, index) => <tr key={index}><td><Link to={'/einstaklingur/'+einstaklingur.einstaklingur.id}>{einstaklingur.einstaklingur.nafn}</Link></td><td>{einstaklingur.hlutverk ? einstaklingur.hlutverk.hlutverk : ''}</td></tr>)
													}
												</tbody>
											</table>
										</React.Fragment>
									}

									{
										item.baeir && item.baeir.length > 0 &&
										<React.Fragment>
											<h5>Tengdir bæir</h5>
											<table className="table">
												<tbody>
													{
														item.baeir.map((item, index) => <tr key={index}><td><Link to={'/baer/'+item.id}>{item.baejarnafn}</Link>, {(item.sveitarfelag && item.hreppur ? item.sveitarfelag.nafn+' ('+item.hreppur.nafn+'), ' : '')}{item.sysla.nafn.replace(/(.*?)a$/,'$1u')})</td></tr>)
													}
												</tbody>
											</table>
										</React.Fragment>
									}

									<AbendingForm entityId={item.id} entityType="ornefnaskra" entityName={item.titill}>
										<h3>Senda ábendingu</h3>
										<p>Senda ábendingu varðandi örnefnaskrána <strong>{item.titill}</strong>.</p>
									</AbendingForm>

									{/*
									<hr/>

									<p><strong>Tengdar örnefnaskrár (ÓVIRKT):</strong></p>

									<table className="table">
										<thead>
											<tr>
												<th></th><th>Tegund</th><th></th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td><Link to="/ornefnaskra/2">Stóri-Ás. Spurningar</Link></td><td>Spurningarlisti, jörð</td><td><BookmarkButton id={21} title={'Stóri-Ás. Spurningar'} baer={'Stóri-Ás'} baer_id={2} type={'skra'} className="small" /></td>
											</tr>
											<tr>
												<td><Link to="/ornefnaskra/3">Stóri-Ás. Ari Gíslason</Link></td><td>Athugasemdir og viðbætur, jörð</td><td><BookmarkButton id={3} title={'Stóri-Ás. Ari Gíslason'} type={'skra'} className="small" /></td>
											</tr>
										</tbody>
									</table>
									*/}

								</div>

								<div className={'results-column col col-12 col-md-7'}>

									<div className="tabs-wrapper border">

										<div className="column-heading narrow">
											<a className="float-right btn btn-primary badge badge-secondary" onClick={() => {
												this.setState({
													maximizeResults: !this.state.maximizeResults
												});
											}}>{this.state.maximizeResults ? 'Minnka' : 'Stækka'}</a>

											<ul className="nav nav-tabs">
												{
													item.pdf && item.pdf.pdf_url &&
													<li className="nav-item">
														<Link to={'/ornefnaskra/'+item.id+'/pdf'} className={'nav-link'+(this.state.selectedTab == 'pdf' ? ' active' : '')}>Örnefnaskrá</Link>
													</li>
												}
												{
													item.ornefni && item.fjoldi_ornefna > 0 &&
													<li className="nav-item">
														<Link to={'/ornefnaskra/'+item.id+'/ornefni'} className={'nav-link'+(this.state.selectedTab == 'ornefni' ? ' active' : '')}>Örnefni</Link>
													</li>
												}
												{
													this.state.mapData && this.state.mapData.length > 0 &&
													<li className="nav-item">
														<Link to={'/ornefnaskra/'+item.id+'/kort'} className={'nav-link'+(this.state.selectedTab == 'kort' ? ' active' : '')}>Kort</Link>
													</li>
												}
											</ul>

										</div>

										<div className="tabs-content">

											{
												item.pdf && item.pdf.pdf_url &&
												<div className={'tab padding-0'+(this.state.selectedTab == 'pdf' ? ' visible' : '')}>
													<PdfView url={item.pdf.pdf_url} />
												</div>
											}

											{
												item.ornefni && item.fjoldi_ornefna > 0 &&
												<div className={'tab'+(this.state.selectedTab == 'ornefni' ? ' visible' : '')}>
													<table className="table">
														<thead>
															<tr><th>Örnefni</th><th></th></tr>
														</thead>
														<tbody>
															{
																item.ornefni.map((ornefni, index) => <tr key={index}><td><Link to={'/ornefni/'+ornefni.id}>{ornefni.ornefni}</Link></td><td>{ornefni.uuid && <div className="placename-icon" onClick={() => {
																	this.setState({
																		selectedTab: 'kort'
																	}, () => {
																		setTimeout(() => this.mapView.current.highlighLmiVector(ornefni.uuid), 500);
																	})
																}} />}</td></tr>)
															}
														</tbody>
													</table>
												</div>
											}

											<div className={'tab padding-0'+(this.state.selectedTab == 'kort' ? ' visible' : '')}>
												<MapView ref={this.mapView}
													viewInTabs={true}
													selectedTab={this.state.selectedTab}
													mapData={this.state.mapData}
													overlayListData={this.state.mapListData}
													overlayVisible={true}
													featureData={this.state.featureData}
												></MapView>
											</div>


										</div>

									</div>

								</div>

							</div>

						</div>
					}
				</div>

			</div>
		);
	}
}

export default withRouter(OrnefnaskraView);



// WEBPACK FOOTER //
// ./src/components/OrnefnaskraView.js